import baseElement from '@/mixins/base-element/base-element-dumb';

export default {
    mixins: [baseElement],

    created() {
        this.templateType = this.$options.name;
    },
};
